import ActionsPage from '../ActionsPage';
import { SwitchSupplementsAnnulments } from './SwitchSupplementsAnnulments';

export const ActionsPageSupplementsAnnulments = () => (
  <ActionsPage
    title="Gestión de suplementos y anulaciones"
    switchAction={<SwitchSupplementsAnnulments />}
  />
);
